import APP_CONFIG from 'constants/clientConfigs'

export default function TrustedBrands() {
  const clientConfig = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]
  const brands = clientConfig.brands
  const clientBaseUrl = clientConfig.clientUrl.endsWith('/')
    ? clientConfig.clientUrl
    : `${clientConfig.clientUrl}/`

  return (
    <div className="bg-white py-4 sm:py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg/8 font-semibold text-gray-900">
          Trusted by World’s best brands:
        </h2>

        <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          {brands.map((brand) => (
            <a
              href={
                brand.url ??
                `${clientBaseUrl}${(brand.slug ?? brand.name).replace(/\s+/g, '-').toLowerCase()}`
              }
              key={brand.name}
              target="_blank"
              rel="noreferrer noopener"
              className="col-span-2 max-h-12 w-full lg:col-span-1"
            >
              <img
                alt={brand.name}
                src={brand.logo}
                width={158}
                height={48}
                className="max-h-12 w-full object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
